import React from 'react';
import clsx from 'clsx';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography, { Props as TypographyProps } from '@smart-tv/components/typography/typography';

import styles from './content-item.module.scss';

interface Props extends TypographyProps {
  className?: string;
}

export const ContentItemTitle: React.FC<Props> = (props: Props) => {
  const { children, className, ...rest } = props;

  return (
    <Typography
      component="div"
      data-testid={testIds.contentItem.title}
      {...rest}
      variant="caption"
      className={clsx(styles['title'], className)}
    >
      {children}
    </Typography>
  );
};

export default ContentItemTitle;
